module.exports = __webpack_public_path__ + "static/cover-7acc858908b6fc8ab3a1a329da49b5c3.png";